/**
 * Demir — article table of contents.
 *
 * Builds the "In this guide" panel from the H2s already in the article body,
 * so it stays correct no matter what the content team publishes. Nothing is
 * rendered server-side because the body is merchant HTML — the headings only
 * exist once the article is on the page.
 *
 * Bails out (and leaves the panel hidden) when an article has fewer than
 * MIN_SECTIONS headings; a contents list that repeats a short post's whole
 * body is noise, not navigation.
 */
(() => {
  const MIN_SECTIONS = 3;

  const slugify = (text, used) => {
    const base =
      text
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 60) || 'section';

    // Duplicate headings are common ("Overview"); keep anchors unique.
    let slug = base;
    let n = 2;
    while (used.has(slug)) slug = `${base}-${n++}`;
    used.add(slug);
    return slug;
  };

  const build = (root) => {
    const body = root.querySelector('[data-toc-body]');
    const panel = root.querySelector('[data-toc]');
    const list = root.querySelector('[data-toc-list]');
    if (!body || !panel || !list) return;

    const headings = [...body.querySelectorAll('h2')].filter(
      (h) => h.textContent.trim().length > 0
    );
    if (headings.length < MIN_SECTIONS) return;

    const used = new Set();
    const frag = document.createDocumentFragment();

    headings.forEach((heading) => {
      const text = heading.textContent.trim();
      if (!heading.id) heading.id = slugify(text, used);
      else used.add(heading.id);

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${heading.id}`;
      a.textContent = text;
      li.appendChild(a);
      frag.appendChild(li);
    });

    list.appendChild(frag);
    panel.hidden = false;
  };

  const init = () => {
    document.querySelectorAll('[data-toc-root]').forEach(build);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
